module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2bef63c6b6d3a827d702f23322bb0dea.png";